module.exports = __webpack_public_path__ + "static/media/img_8__2.e42b809b.jpg";